import { T } from 'ramda';
import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setLogoShrinking';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  logoExpanded: () => 0,
  logoExpandedAction: () => 1,
  immediate: T,
});

export const action = {
  [name]: fn,
};

export default action;
